import { render } from "./MuhurthaGraph.vue?vue&type=template&id=761f7ca0&scoped=true"
import script from "./MuhurthaGraph.vue?vue&type=script&lang=js"
export * from "./MuhurthaGraph.vue?vue&type=script&lang=js"

import "./MuhurthaGraph.vue?vue&type=style&index=0&id=761f7ca0&scoped=true&lang=css"

import exportComponent from "C:\\TK\\LivppyLab\\LivppyLab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f7ca0"]])

export default __exports__